
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import {
  Dialog, 
  DialogContent, 
  DialogDescription, 
  DialogFooter, 
  DialogHeader, 
  DialogTitle
} from "@/components/ui/dialog";
import { DialogFixUtil } from "@/components/ui/dialog-fix-util";

interface DeleteAssociationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
  isPending: boolean;
}

export const DeleteAssociationDialog: React.FC<DeleteAssociationDialogProps> = ({
  open,
  onOpenChange,
  onDelete,
  isPending
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogFixUtil open={open} />
      <DialogContent 
        onPointerDownOutside={(e) => {
          // Prevent closing when interacting with popover content
          if (e.target instanceof Node) {
            const target = e.target as HTMLElement;
            if (target.closest('[data-radix-popover-content]')) {
              e.preventDefault();
            }
          }
        }}
        onInteractOutside={(e) => {
          // Additional protection against unwanted closing
          const target = e.target as HTMLElement;
          if (target.closest('[data-popover-container]') || 
              target.closest('.tippy-box')) {
            e.preventDefault();
          }
        }}
        onClick={(e) => {
          // Stop propagation to prevent underlying interactions
          e.stopPropagation();
        }}
      >
        <DialogHeader>
          <DialogTitle>Delete Association</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this association? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button 
            variant="destructive" 
            onClick={onDelete}
            disabled={isPending}
          >
            {isPending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              "Delete Association"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
